import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { URLQuery } from "@/utils/queryUtils";
import { validationConstants, validationFunctions } from "@/utils/validationUtils";
import { App as AntApp, Button, Card, Input } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import AntIcon from "../../../common/components/icons/AntIcon";
import { AffiliatePartnerModalForm } from "../components/forms/AffiliatePartnerModalForm";
import { AffiliatePartnerTableView } from "../components/views/AffiliatePartnerTableView";
import { AffiliatePartner } from "../types";

export const AffiliatePartnerListContainer = () => {
  const { t } = useTranslation();
  const { message } = AntApp.useApp();

  const [partnerFormOpen, setPartnerFormOpen] = useState(false);
  const [partnerToUpdate, setPartnerToUpdate] = useState<AffiliatePartner>();

  const navigate = useNavigate();
  const keywordSearchParam = useFilterSearchParams().keyword;

  const handleSearchSubmit = (keyword: string) => {
    if (validationFunctions.validateSearchKeyword(keyword)) {
      navigate(
        {
          search: URLQuery.searchParamsToString({
            searchParams: { keyword },
          }),
        },
        { replace: true },
      );
    } else {
      message.error(
        t("validation.size", {
          min: validationConstants.SEARCH_KEYWORD_MIN_LENGTH,
          max: validationConstants.SEARCH_KEYWORD_MAX_LENGTH,
        }),
      );
    }
  };

  const handleCreateClick = () => {
    setPartnerToUpdate(undefined);
    setPartnerFormOpen(true);
  };

  const handleUpdateClick = (affiliatePartner: AffiliatePartner) => {
    setPartnerToUpdate(affiliatePartner);
    setPartnerFormOpen(true);
  };

  const handleFormCancel = () => {
    setPartnerFormOpen(false);
    setPartnerToUpdate(undefined);
  };

  return (
    <ContentWrapper>
      <Card
        className="card-box"
        title={<h2>{t("affiliatePartner.titles.list")}</h2>}
        extra={
          <>
            <Button
              className="margin-right-small"
              type="primary"
              icon={<AntIcon type="plus" />}
              onClick={handleCreateClick}
            >
              {t("affiliatePartner.actions.createPartner")}
            </Button>

            <Input.Search
              style={{ width: 350 }}
              enterButton
              allowClear
              placeholder={t("affiliatePartner.helpers.searchHint")}
              defaultValue={keywordSearchParam}
              onSearch={handleSearchSubmit}
            />
          </>
        }
      >
        <AffiliatePartnerTableView onUpdateClick={handleUpdateClick} />
      </Card>

      <AffiliatePartnerModalForm
        affiliatePartner={partnerToUpdate}
        open={partnerFormOpen}
        onFormCancel={handleFormCancel}
      />
    </ContentWrapper>
  );
};
